import { ZodError, ZodSchema } from 'zod';

export function checkWithZod<T>(input: ZodSchema<T>, object: T): boolean {
	try {
		input.parse(object);
		return true;
	} catch (e) {
		const error = e as ZodError;

		console.groupCollapsed(`🚨 ZOD-Error (${error.errors.length})`);

		console.group(error.errors.length + ' Errors');
		for (const i of error.errors) {
			console.info(
				'%c ' + i.message + ' %c\n' + i.path.join('/'),
				'background: darkBlue; color: white',
				''
			);
		}
		console.groupEnd();

		console.groupCollapsed('Trancing');
		console.trace('zod-error');
		console.groupEnd();

		console.groupEnd();
		return false;
	}
}

export function createValidator<T>(schema: ZodSchema<T>) {
	return (input: { data: T }): boolean => {
		return checkWithZod(schema, input.data);
	};
}
